import { ReactComponent as AppStoreLogo } from '@/assets/images/svg/logos/downloads/app-store.svg';
import { ReactComponent as AppleLogo } from '@/assets/images/svg/logos/downloads/mac.svg';
import { ReactComponent as PlayStoreLogo } from '@/assets/images/svg/logos/downloads/play-store.svg';
import { ReactComponent as WindowsLogo } from '@/assets/images/svg/logos/downloads/windows.svg';
import { ReactNode } from 'react';
import { APP_DOMAIN } from './routes';

export const DOWNLOAD_PAGE_HEADLINE = 'Stay connected from any device';
export const DOWNLOAD_PAGE_TEXT =
  "Whether you're at your desk or on the go, Front keeps your messages, apps, and teammates at your fingertips.";

export const DOWNLOAD_PAGE_DESKTOP_APPS: AppDownload[] = [
  {
    key: 'mac-intel',
    title: 'Front for macOS',
    type: 'Desktop App',
    url: 'https://dl.frontapp.com/macos/Front-universal.dmg',
    logo: <AppleLogo />,
  },
  {
    key: 'windows',
    title: 'Front for Windows',
    type: 'Desktop App',
    url: 'https://dl.frontapp.com/win32/FrontSetup.exe',
    logo: <WindowsLogo />,
  },
];

export const DOWNLOAD_PAGE_MOBILE_APPS: AppDownload[] = [
  {
    key: 'ios',
    title: 'Front for iOS',
    type: 'Mobile App',
    url: 'https://itunes.apple.com/us/app/frontapp/id983808769?mt=8',
    logo: <AppStoreLogo />,
  },
  {
    key: 'android',
    title: 'Front for Android',
    type: 'Mobile App',
    url: 'https://play.google.com/store/apps/details?id=com.frontapp.mobile',
    logo: <PlayStoreLogo />,
  },
];

export const DOWNLOAD_PAGE_WEB_APP_URL = APP_DOMAIN;
export const DOWNLOAD_PAGE_WEB_APP_LINK_TEXT = 'Launch Front on the web';

type AppDownload = {
  key: string;
  title: string | [string, string];
  type: string;
  url: string;
  logo: ReactNode;
};
